import React, { useState } from 'react';
import Button from '../../components/Button';
import Link from '../../utils/router/Link';
import AccountContentContainer from '../AccountContentContainer';
import LoginHandler from '../LoginHandler';
import IntegrationLoginButtons from './IntegrationLoginButtons';
import LoginPasswordFormView from './LoginPasswordFormView';
import * as styles from './LoginView.module.scss';

const { __slab } = window;

const LoginView = () => {
  const [isShowingGuestLogin, setIsShowingGuestLogin] = useState(false);
  const {
    email,
    effectiveHost,
    name,
    ssoPlatforms,
    settings: { authentication: authenticationSetting },
  } = window.__slab.PUBLIC_ORG;

  const isForceLoginPasswordForm =
    ssoPlatforms.length === 0 || isShowingGuestLogin;

  return (
    <AccountContentContainer
      title={`Log into ${name}`}
      subtitle={effectiveHost}
    >
      <LoginHandler>
        <IntegrationLoginButtons email={email} ssoPlatforms={ssoPlatforms} />
        {authenticationSetting !== 'SSO_ONLY' && ssoPlatforms.length > 0 && (
          <AccountContentContainer.Divider />
        )}
        {(authenticationSetting === 'SSO_AND_PASSWORD' ||
          isForceLoginPasswordForm) && (
          <>
            {ssoPlatforms.length > 0 && (
              <div className={styles.emailText}>
                Log in with your email and password
              </div>
            )}
            <LoginPasswordFormView />
          </>
        )}
        {authenticationSetting === 'SSO_AND_GUEST_PASSWORD' &&
          !isForceLoginPasswordForm && (
            <Button
              block
              onClick={() => setIsShowingGuestLogin(true)}
              variant="secondary"
            >
              Log in with a guest account
              <AccountContentContainer.ButtonInstruction>
                using email and password
              </AccountContentContainer.ButtonInstruction>
            </Button>
          )}
      </LoginHandler>
      <p className={styles.terms}>
        <span>By using Slab, you agree to the </span>
        <Link to={`//${__slab.HOST}/terms`}>Terms of Service</Link>
        <span> and </span>
        <Link to={`//${__slab.HOST}/privacy`}>Privacy Policy</Link>
      </p>
    </AccountContentContainer>
  );
};

export default LoginView;
